export enum STATUS {
    ALL = -1,
    ACTIVE = 1,
    INACTIVE = 0,
    ScheduleOver = 2,
    DailyBudgetOver = 4,
    TotalBudgetOver = 8,
    DailyImpOver = 16,
    TotalImpOver = 32,
    DailyClickOver = 64,
    TotalClickOver = 128,
    DailyConvOver = 256,
    TotalConvOver = 512,
    Deleted = 1024,
    EqualityBudgetOver = 2048,
}
export const STATUS_EXPLAINING = {
    [STATUS.ACTIVE]: '활성화',
    [STATUS.INACTIVE]: '비활성화',
    [STATUS.ScheduleOver]: '광고 일정 기간 아님',
    [STATUS.DailyBudgetOver]: '일일 예산 초과',
    [STATUS.TotalBudgetOver]: '총 예산 초과',
    [STATUS.DailyImpOver]: '일일 노출 달성',
    [STATUS.TotalImpOver]: '총 노출 달성',
    [STATUS.DailyClickOver]: '일일 클릭 달성',
    [STATUS.TotalClickOver]: '총 클릭 달성',
    [STATUS.DailyConvOver]: '일일 전환 달성',
    [STATUS.TotalConvOver]: '총 전환 달성',
    [STATUS.Deleted]: '삭제됨',
    [STATUS.EqualityBudgetOver]: '균등 노출 예산 초과',
}

export enum AUDIENCE_STATUS {
    SETUP = 0,
    PROGRESS = 1,
    DONE = 2,
    ABORT = 3,
    READY = 4,
    DORMANCY = 5,
    DELETED = 127,

    ALL = -1,
}